/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const FilePdf16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray50}
            fillRule="evenodd"
            d="M4.933 6.998c0 .354-.054.66-.162.918a1.743 1.743 0 01-1.044 1.012 2.033 2.033 0 01-.693.122h-.621v2.322H1V5h1.98c.228 0 .457.033.688.099a1.655 1.655 0 011.09.945c.117.258.175.576.175.954zm-1.35.027c0-.288-.069-.495-.207-.621a.72.72 0 00-.504-.189h-.459V7.88h.459a.665.665 0 00.504-.22c.138-.148.207-.359.207-.635zm6.854 1.179c0 .48-.052.915-.157 1.305-.106.39-.266.723-.482.999-.216.276-.49.489-.823.639-.334.15-.728.225-1.184.225H6V5h1.791c.456 0 .85.075 1.184.225.333.15.607.364.823.644.216.279.376.614.482 1.008.105.393.157.835.157 1.327zm-1.449 0c0-.642-.11-1.126-.329-1.454-.219-.327-.502-.49-.85-.49h-.351v3.852h.351c.348 0 .631-.163.85-.49.22-.328.329-.8.329-1.418zm3.961-1.899v1.296h1.521v1.233h-1.512v2.538H11.5V5h3.105v1.305h-1.656z"
        />
    </AccessibleSVG>
);

export default FilePdf16;
